/* ============================================================
   TORPION THEME — theme.js
   ============================================================ */
(function(){
  "use strict";

  /* ---------- page enter ---------- */
  document.documentElement.classList.add("js");

  /* ---------- world flash on brand navigation ---------- */
  var FLASH = {rfn:"#de2e1e","79bike":"#7e63ff",surron:"#ff5a1f",torpion:"#0a6cff"};
  function playFlash(theme){
    var f=document.getElementById("worldFlash");
    if(!f) return;
    f.style.background=FLASH[theme]||"#0a6cff";
    f.classList.remove("go"); void f.offsetWidth; f.classList.add("go");
  }
  document.addEventListener("click",function(e){
    var a=e.target.closest("a[data-world]");
    if(a){ try{sessionStorage.setItem("torpion_world",a.getAttribute("data-world"));}catch(err){} }
  });
  try{
    var w=sessionStorage.getItem("torpion_world");
    if(w){
      sessionStorage.removeItem("torpion_world");
      var bt=document.body.getAttribute("data-theme");
      if(w===bt) playFlash(bt);
    }
  }catch(err){}

  /* ---------- mobile menu ---------- */
  var burger=document.getElementById("burger"), mm=document.getElementById("mobileMenu");
  if(burger&&mm){
    burger.addEventListener("click",function(){ mm.classList.toggle("open"); document.body.style.overflow=mm.classList.contains("open")?"hidden":""; });
    mm.querySelectorAll("a").forEach(function(a){a.addEventListener("click",function(){mm.classList.remove("open");document.body.style.overflow="";});});
  }

  /* ---------- reveal on scroll ---------- */
  var reveals=document.querySelectorAll(".reveal");
  if("IntersectionObserver" in window && reveals.length){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target);} });
    },{threshold:.12,rootMargin:"0px 0px -8% 0px"});
    reveals.forEach(function(el){io.observe(el);});
  } else { reveals.forEach(function(el){el.classList.add("in");}); }

  /* ---------- toast ---------- */
  var toastTimer;
  window.torpionToast=function(msg){
    var t=document.getElementById("toast"); if(!t) return;
    t.textContent=msg; t.classList.add("show");
    clearTimeout(toastTimer); toastTimer=setTimeout(function(){t.classList.remove("show");},2600);
  };

  /* ---------- money formatting (alle Shopify-Formate) ---------- */
  function formatMoney(cents, fmt){
    fmt = fmt || "€{{amount_with_comma_separator}}";
    function fmtNum(n, dec, th, ds){
      var s = (n/100).toFixed(dec).split(".");
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s.length > 1 ? s[0] + ds + s[1] : s[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function(_, key){
      switch(key){
        case "amount_no_decimals": return fmtNum(cents, 0, ",", ".");
        case "amount_with_comma_separator": return fmtNum(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmtNum(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return fmtNum(cents, 2, "'", ".");
        case "amount_with_space_separator": return fmtNum(cents, 2, " ", ",");
        case "amount_no_decimals_with_space_separator": return fmtNum(cents, 0, " ", ",");
        default: return fmtNum(cents, 2, ",", ".");
      }
    });
  }
  window.torpionMoney = formatMoney;

  /* ---------- product gallery (Legacy) ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function(g){
    var main=g.querySelector("[data-gallery-main]");
    g.querySelectorAll("[data-thumb]").forEach(function(btn){
      btn.addEventListener("click",function(){
        if(main) main.src=btn.getAttribute("data-img");
        g.querySelectorAll("[data-thumb]").forEach(function(b){b.classList.remove("active");});
        btn.classList.add("active");
      });
    });
  });

  /* ---------- variant picker ---------- */
  document.querySelectorAll("[data-product-form]").forEach(function(form){
    var data;
    try{ data=JSON.parse(form.querySelector("[data-variants]").textContent); }catch(e){ data=[]; }
    var idInput=form.querySelector("[data-variant-id]");
    var priceNow=document.querySelector("[data-price-now]");
    var priceWas=document.querySelector("[data-price-was]");
    var priceSave=document.querySelector("[data-price-save]");
    var addBtn=form.querySelector("[data-add]");
    var galleryMain=document.querySelector("[data-gallery-main]");
    var moneyFmt=form.getAttribute("data-money");

    function money(cents){ return formatMoney(cents, moneyFmt); }
    function selectedOptions(){
      return Array.prototype.map.call(form.querySelectorAll("[data-opt]:checked"),function(i){return i.value;});
    }
    function findVariant(opts){
      return data.find(function(v){ return v.options.length===opts.length && v.options.every(function(o,i){return o===opts[i];}); });
    }
    function update(){
      var opts=selectedOptions();
      var v= opts.length? findVariant(opts) : data[0];
      if(!v){
        if(addBtn){ addBtn.disabled=true; addBtn.textContent="Nicht verfügbar"; }
        return;
      }
      if(idInput) idInput.value=v.id;
      if(priceNow) priceNow.textContent=money(v.price);
      if(priceWas){
        if(v.compare_at_price && v.compare_at_price>v.price){
          priceWas.textContent=money(v.compare_at_price); priceWas.style.display="";
          if(priceSave){ priceSave.textContent="Spare "+money(v.compare_at_price - v.price); priceSave.style.display=""; }
        } else { priceWas.style.display="none"; if(priceSave) priceSave.style.display="none"; }
      }
      if(addBtn){
        if(v.available){ addBtn.disabled=false; addBtn.textContent=addBtn.getAttribute("data-label-add")||"In den Warenkorb"; }
        else { addBtn.disabled=true; addBtn.textContent="Ausverkauft"; }
      }
      if(galleryMain && v.featured_image){ galleryMain.src=v.featured_image; }
    }
    form.querySelectorAll("[data-opt]").forEach(function(i){ i.addEventListener("change",update); });
    update();

    /* ---------- ajax add to cart ---------- */
    form.addEventListener("submit",function(e){
      if(!window.fetch) return;
      e.preventDefault();
      var fd=new FormData(form);
      if(addBtn){ addBtn.disabled=true; addBtn.textContent="Hinzufügen…"; }
      fetch("/cart/add.js",{method:"POST",headers:{"X-Requested-With":"XMLHttpRequest"},body:fd})
        .then(function(r){ if(!r.ok) throw new Error("add"); return r.json();})
        .then(function(){ return fetch("/cart.js"); })
        .then(function(r){return r.json();})
        .then(function(cart){
          updateCartCount(cart.item_count);
          window.torpionToast&&window.torpionToast("Zum Warenkorb hinzugefügt");
          if(addBtn){ addBtn.disabled=false; addBtn.textContent=addBtn.getAttribute("data-label-add")||"In den Warenkorb"; }
        })
        .catch(function(){ form.submit(); });
    });
  });

  function updateCartCount(n){
    var c=document.getElementById("cartCount");
    if(!c) return;
    c.textContent=n;
    c.classList.toggle("show", n>0);
  }

  /* ---------- qty steppers (product + cart) ---------- */
  document.querySelectorAll("[data-qty]").forEach(function(box){
    var input=box.querySelector("input");
    box.querySelector("[data-qd]")&&box.querySelector("[data-qd]").addEventListener("click",function(){
      input.value=Math.max(1,(parseInt(input.value,10)||1)-1); input.dispatchEvent(new Event("change",{bubbles:true}));
    });
    box.querySelector("[data-qu]")&&box.querySelector("[data-qu]").addEventListener("click",function(){
      input.value=(parseInt(input.value,10)||1)+1; input.dispatchEvent(new Event("change",{bubbles:true}));
    });
  });
})();
